import { selectCountries } from 'legacy/lut/selectors/app'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { MarketApi } from 'core/classes/services/api/MarketApi'

export const useTerritoryOfSaleRootEMEA = (partnerCountryName: string) => {
  const countries = useSelector(selectCountries)

  return useMemo(() => {
    const country = countries.find((i) => i.name === partnerCountryName)
    const region = MarketApi.getRegion(country?.market || '').Region || undefined

    return region ? `Region-${region}` : undefined
  }, [partnerCountryName, countries])
}
